// src/components/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/img/logo.png';
import '../styles/Header.css';

function Header() {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  return (
    <header className="main-header">
      <div className="header-container">
        <div className="logo">
          <img src={logo} alt="RoboticMinds Logo" />
        </div>

        <div className="nav-wrapper">
          <button
            className="menu-toggle"
            onClick={() => setOpen(o => !o)}
            aria-label="Toggle navigation"
          >
            ☰
          </button>

          <nav className={`main-nav ${open ? 'open' : ''}`}>
            <ul>
              {['/', '/trabaja-con-nosotros','/login'].map((to, i) => {
                const labels = ['Inicio', 'Trabaja con nosotros','Ingresar'];
                return (
                  <li key={to}>
                    <Link to={to} onClick={handleClose}>
                      {labels[i]}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
